<main class="main-wrap">
    <div class="wrapper">
      <div class="">
  
          <!-- sign up start -->
  
          <div class="main-bg">
              <div class="mx-1485 pt-0 w-100">
                  <div class="row align-items-center">
                      <div class="col-lg-6">
                          <div class="login-logo">
                              <a href="#"><img src="assets/images/login-logo.svg" alt="logo"></a>
                          </div>
                      </div>
                      <div class="col-lg-6">
                          <div class="login-box h-unset" *ngIf="viewForm == ''" >
                              <h4>Create an account</h4>
                              <div class="sign-up-with-email">Sign up with email</div>
                              <div class="already-account">
                                  <span>Already have an account? <a href="sign-in">Sign in</a></span>
                              </div>
                              <form [formGroup]="registerFormgroup" (ngSubmit)="onSubmit('register')">
                                <div class="row">
                                    <div class="col-sm-6 col-12">
                                        <div class="mb-4">
                                            <label>First Name<span style="color:red;">*</span> </label>
                                            <input type="text" formControlName="first_name">
                                            <div *ngIf="f['first_name'].touched && f['first_name'].invalid" class="alert alert-text  alert-danger alert-text">
                                                <div *ngIf="f['first_name'].errors && f['first_name'].errors['required']">First Name is required.
                                                </div>
                                              </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-6 col-12">
                                        <div class="mb-4">
                                            <label>Last Name <span style="color:red;">*</span></label>
                                            <input type="text"  formControlName="last_name">
                                            <div *ngIf="f['last_name'].touched && f['last_name'].invalid" class="alert alert-text  alert-danger alert-text">
                                                <div *ngIf="f['last_name'].errors && f['last_name'].errors['required']">Last Name is required.
                                                </div>
                                              </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-6 col-12">
                                        <div class="mb-4">
                                            <label>Mobile Number</label>
                                            <input type="tel" maxlength="10" minlength="10" class="" id="phone_number" formControlName="phone_number"
                                            placeholder="Mobile Number.."
                                            oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1').replace(/^0[^.]/, '0');">
                                            <div *ngIf="f['phone_number'].touched && f['phone_number'].invalid"
                                                class="alert alert-danger alert-text">
                                            <div *ngIf="f['phone_number'].errors && f['phone_number'].errors['required']">Mobile Number is
                                                required.</div>
                                            <div *ngIf="f['phone_number'].hasError('pattern')">
                                                Mobile Number is invalid.
                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-6 col-12">
                                        <div class="mb-4">
                                            <label>Email</label>
                                            <input type="email"  formControlName="email">
                                        </div>
                                    </div>
                                    <div class="col-sm-6 col-12">
                                        <div class="mb-4">
                                            <label>Gender</label><br>
                                           <input type="radio" class="me-2"  formControlName="gender" value="1" /><label class="me-3">Male</label>
                                           <input type="radio" class="me-2"  formControlName="gender" value="2" /><label >Female</label>
                                         </div>
                                    </div>
                                    <div class="col-sm-6 col-12">
                                        <div class="mb-4">
                                            <label>Date Of Birth</label>
                                            <input type="date"  formControlName="birth_date">
                                         </div>
                                    </div>
                                    <div class="col-sm-6 col-12">
                                        <div class="mb-4">
                                            <label>Alternate Mobile Number</label>
                                            <input type="tel" maxlength="10" minlength="10" class="" id="alternate_mob_no" formControlName="alternate_mob_no"
                                            placeholder="Mobile Number.."
                                            oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1').replace(/^0[^.]/, '0');">
                                            <div *ngIf="f['alternate_mob_no'].touched && f['alternate_mob_no'].invalid"
                                                class="alert alert-danger alert-text">
                                            <div *ngIf="f['alternate_mob_no'].hasError('pattern')">
                                                Mobile Number is invalid.
                                            </div>
                                            </div>
                                         </div>
                                    </div>
                                    <div class="d-flex justify-content-end">
                                        <button type="submit">Continue</button>
                                    </div>
                                </div>
                              </form>
                              
                          </div>
                           <!-- Verify OTP Screen -->
                        <div class="login-box h-unset" *ngIf="viewForm == 'register'">
                            <h4>Verify OTP</h4>
                            
                            <form [formGroup]="verifyOtpFormgroup" (ngSubmit)="onSubmit('verifyOTP')">
                                <div class="row">
                                  <div class="form-group col-md-12 mb-4">
                                    <input type="tel" maxlength="4" minlength="4" id="otp" formControlName="otp"
                                      placeholder="Enter OTP"
                                      oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1').replace(/^0[^.]/, '0');">
                                    <div *ngIf="otpf['otp'].touched && otpf['otp'].invalid"
                                      class="alert alert-danger alert-text">
                                      <div *ngIf="otpf['otp'].errors && otpf['otp'].errors['required']">OTP is
                                        required.</div>
                                      <div *ngIf="otpf['otp'].hasError('pattern')">
                                       OTP is invalid.
                                      </div>
                                    </div>
                                  </div>
                  
                                  <div class="col-md-12">
                                    <button type="submit" [disabled]="verifyOtpFormgroup.invalid" class="verify-otp-btn btn btn-primary btn-block mb-4">Verify OTP</button>
                                  </div>
                                </div>
                              </form>
                        </div>
                      </div>
                  </div>
              </div>
          </div>
          <!-- sign up end -->
      </div>
    </div>
  </main>